import { render, staticRenderFns } from "./assign-label-modal.vue?vue&type=template&id=20e84264&scoped=true&"
import script from "./assign-label-modal.vue?vue&type=script&lang=ts&"
export * from "./assign-label-modal.vue?vue&type=script&lang=ts&"
import style0 from "./assign-label-modal.vue?vue&type=style&index=0&id=20e84264&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e84264",
  null
  
)

export default component.exports